import React from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';

import Navbar from './components/navbar/Navbar';
// import Footer from "./components/footer/Footer";

import './styles/global.scss';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Home from './pages/Home/Home';
import NewsTopicPage from './pages/newsTopic/NewsTopicPage';
import DetailView from './pages/DetailVew/DetailView';
import NotFound from './pages/NotFound/NotFound';

const queryClient = new QueryClient();

function App() {
  const Layout = () => {
    return (
      <div>
        <Navbar />
        <div className="container">
          <div className="contentContainer">
            <QueryClientProvider client={queryClient}>
              <Outlet />
            </QueryClientProvider>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    );
  };
  // 14:56
  const router = createBrowserRouter(
    [
      {
        path: '/',
        element: <Layout />,
        children: [
          { path: '/', element: <Home />, children: [{ path: '/seamansnews', element: <Home /> }] },
          { path: '/newsTopic/', element: <NewsTopicPage />, children: [{ path: '/newsTopic/:id', element: <NewsTopicPage /> }] },
          { path: '/news/:id', element: <DetailView /> },
          { path : '/*' , element:<NotFound/>}
        ],
      },
    ],
    { basename: '/seamansclub-news' },
  );

  return <RouterProvider router={router} />;
}

export default App;
